export enum OrderCheckoutState {
  STATE_CART = 'cart',
  STATE_CUSTOMER_DETAILS = 'customer_details',
  STATE_COMPLETED = 'completed',
  STATE_EXPIRED = 'expired',
}
